import CustomerConfirm from "@/common/utils/CustomerConfirm.jsx";
import ConfirmFooter from "@/pages/components/ConfirmFooter/index.jsx";
import ApplicationTypeFilter from "@/pages/components/ApplicationTypeFilter/index.jsx";
import CoverImage from "@/pages/components/CoverImage/index.jsx";
import { getWorkFlowList, getAgentList } from "@/services/workflow.js";
import { getApplicationList } from "@/services/application.js";

import styles from './index.module.scss';
import {useEffect, useRef, useState} from "react";
import {Table, Tabs, Input, Space, Button, Tag, Modal} from "antd";
import {delRepeatData} from "@/lib/utils.js";
import ReactDOM from "react-dom/client";

const { Search } = Input;

// 状态映射
const STATUS_OPTIONS = [
  { label: '离线', value: 'OFFLINE' },
  { label: '在线', value: 'ONLINE' },
  { label: '测试', value: 'TEST' }
];

const STATUS_COLOR_MAP = {
  OFFLINE: 'default',
  ONLINE: 'success',
  TEST: 'warning'
};

function ChoiceApplicationContent({choiceIds, onChange, type}) {

  const [activeTab, setActiveTab] = useState(type || 'APP');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentSelectItems, setCurrentSelectItems] = useState([]);
  const [appFilterInfo, setAppFilterInfo] = useState({ key: 'AMAZON', childKey: 'AMAZON_1', value: '' });
  const [total, setTotal] = useState(0);

  const pageInfo = useRef({
    current: 1,
    pageSize: 20,
  });

  // 根据不同类型定义不同的列
  const getColumns = (tabType) => {
    if (tabType === 'WORKFLOW') {
      return [
        {
          title: '封面',
          dataIndex: 'coverImage',
          key: 'coverImage',
          width: 80,
          render: (coverImage) => (
            <CoverImage 
              coverImage={coverImage} 
              width={60}
              height={40}
            />
          ),
        },
        {
          title: '工作流名称',
          dataIndex: 'name',
          key: 'name',
          width: 200,
          render: (_, record) => (
            <div>
              <div style={{ fontWeight: 500 }}>{record.name}</div>
              {record.nameEn && record.name !== record.nameEn && (
                <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>{record.nameEn}</div>
              )}
            </div>
          ),
        },
        {
          title: '工作流ID',
          dataIndex: 'id',
          key: 'id',
          width: 100,
        },
        {
          title: '唯一标识',
          dataIndex: 'sign',
          key: 'sign',
          width: 120,
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          width: 80,
          render: (status) => (
            <Tag color={STATUS_COLOR_MAP[status]} size="small">
              {STATUS_OPTIONS.find(s => s.value === status)?.label || status}
            </Tag>
          ),
        },
        {
          title: '评分',
          dataIndex: 'points',
          key: 'points',
          width: 100,
          render: (points) => {
            if (!points || points === 0) {
              return <span style={{ color: '#999' }}>暂无评分</span>;
            }
            const stars = '⭐'.repeat(Math.min(Math.max(Math.floor(points), 1), 5));
            return (
              <span style={{ color: '#faad14' }}>
                {stars} {points}
              </span>
            );
          },
        },
        {
          title: '创建者',
          dataIndex: 'createBy',
          key: 'createBy',
          width: 100,
        }
      ];
    } else if (tabType === 'AGENT') {
      return [
        {
          title: '封面',
          dataIndex: 'coverImage',
          key: 'coverImage',
          width: 80,
          render: (coverImage) => (
            <CoverImage 
              coverImage={coverImage} 
              width={60}
              height={40}
            />
          ),
        },
        {
          title: '工作流名称',
      dataIndex: 'name',
      key: 'name',
          width: 180,
          render: (_, record) => (
            <div>
              <div style={{ fontWeight: 500 }}>{record.name}</div>
              {record.nameEn && record.name !== record.nameEn && (
                <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>{record.nameEn}</div>
              )}
            </div>
          ),
        },
        {
          title: '智能体ID',
          dataIndex: 'id',
          key: 'id',
          width: 100,
        },
        {
          title: '工作流ID',
          dataIndex: 'workFlowId',
          key: 'workFlowId',
          width: 100,
        },
        {
          title: '智能体标识',
          dataIndex: 'sign',
          key: 'sign',
          width: 120,
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          width: 80,
          render: (status) => (
            <Tag color={STATUS_COLOR_MAP[status]} size="small">
              {STATUS_OPTIONS.find(s => s.value === status)?.label || status}
            </Tag>
          ),
        },
        {
          title: '评分',
          dataIndex: 'points',
          key: 'points',
          width: 100,
          render: (points) => {
            if (!points || points === 0) {
              return <span style={{ color: '#999' }}>暂无评分</span>;
            }
            const stars = '⭐'.repeat(Math.min(Math.max(Math.floor(points), 1), 5));
            return (
              <span style={{ color: '#faad14' }}>
                {stars} {points}
              </span>
            );
          },
        },
        {
          title: '创建者',
          dataIndex: 'createBy',
          key: 'createBy',
          width: 100,
        }
      ];
    }

    // APP 类型保持原有的简单列配置
    return [
      {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
        width: 200,
      },
      {
        title: '描述',
        dataIndex: 'description',
        key: 'description',
        ellipsis: true,
      },
      {
        title: '创建者',
        dataIndex: 'createBy',
        key: 'createBy',
        width: 120,
      }
    ];
  };

  useEffect(() => {
    setCurrentSelectItems(choiceIds || []);
  }, [choiceIds]);

  useEffect(() => {
    onChange?.(currentSelectItems);
  }, [currentSelectItems]);

  useEffect(() => {
    if (type && type !== 'APP') {
      // 非APP类型直接加载数据（activeTab已经在useState中设置为type了）
      loadData(type);
    }
    // APP类型等待ApplicationTypeFilter的onChange触发，不需要额外处理
  }, [type]);

  const loadData = async (tabType = activeTab, keyword = searchKeyword, filterInfo = appFilterInfo) => {
    setLoading(true);
    try {
      let res;
      let processedData = [];

      if (tabType === 'WORKFLOW') {
        res = await getWorkFlowList({
          current: pageInfo.current.current,
          pageSize: pageInfo.current.pageSize,
          title: keyword
        });
        
        if (res.success) {
          setTotal(res.total || 0);
          processedData = res.data.map(item => ({
            id: item.id,
            appId: item.id, // 兼容原有字段
            name: item.titleCn || item.title, // 修复名称显示
            nameEn: item.titleEn,
            description: item.detail || item.description,
            createBy: item.createBy,
            sign: item.sign,
            status: item.status,
            coverImage: item.coverImage,
            points: item.points, // 添加评分字段
            type: 'WORKFLOW'
          }));
        }
      } else if (tabType === 'AGENT') {
        res = await getAgentList({
          current: pageInfo.current.current,
          pageSize: pageInfo.current.pageSize,
          title: keyword
        });
        
        if (res.success) {
          setTotal(res.total || 0);
          processedData = res.data.map(item => ({
            id: item.id,
            appId: item.id, // 兼容原有字段
            name: item.workFlow?.titleCn || item.title, // 修复名称显示
            nameEn: item.workFlow?.titleEn,
            description: item.description,
            createBy: item.workFlow?.createBy || item.createBy,
            sign: item.workFlow?.sign || item.sign,
            status: item.workFlow?.status,
            coverImage: item.workFlow?.coverImage,
            workFlowId: item.workFlowId,
            configCn: item.configCn,
            configEn: item.configEn,
            points: item.workFlow?.points, // 添加评分字段
            type: 'AGENT'
          }));
        }
      } else {
        // APP 类型，使用原有的应用接口和过滤器
        res = await getApplicationList({
          type: filterInfo.key,
          typeSubItem: filterInfo.childKey,
          name: filterInfo.value || keyword,
          createBy: 'KERQU',
          current: pageInfo.current.current,
          pageSize: pageInfo.current.pageSize
        });
        
      if (res.success) {
          setTotal(res.total || 0);
          processedData = res.data.map(item => ({
            id: item.appId,
            appId: item.appId,
            name: item.name,
            description: item.description,
            createBy: item.createBy,
            type: 'APP'
          }));
        }
      }

      setData(processedData);
    } catch (error) {
      console.error('加载数据失败:', error);
      setTotal(0);
    }
    setLoading(false);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    
    // 先清空数据避免闪烁
    setData([]);
    setTotal(0);
    
    pageInfo.current = { current: 1, pageSize: 20 };
    if (key === 'APP') {
      // APP类型等待ApplicationTypeFilter的onChange触发，不立即加载数据
      // 因为ApplicationTypeFilter会在组件渲染后自动触发一次onChange
    } else {
      loadData(key, '');
    }
  };

  const handleSearch = (value) => {
    setSearchKeyword(value);
    pageInfo.current = { current: 1, pageSize: 20 };
    loadData(activeTab, value, appFilterInfo);
  };

  const handleAppFilterChange = (filterInfo) => {
    setAppFilterInfo(filterInfo);
    pageInfo.current = { current: 1, pageSize: 20 };
    
    // APP类型只在ApplicationTypeFilter第一次触发时加载数据
    if (activeTab === 'APP') {
      loadData('APP', searchKeyword, filterInfo);
    } else {
      // 非APP类型正常加载数据
      loadData(activeTab, searchKeyword, filterInfo);
    }
  };

  const handleSelect = (record, selected) => {
    setCurrentSelectItems(items => {
      if (selected) {
        return [...items, record];
      } else {
        return items.filter(item => item.id !== record.id);
      }
    });
  };

  const handleSelectAll = (selected, selectedRows, changeRows) => {
    setCurrentSelectItems(items => {
      if (selected) {
        // 添加所有当前页的数据
        const newItems = [...items];
        changeRows.forEach(row => {
          if (!newItems.find(item => item.id === row.id)) {
            newItems.push(row);
          }
        });
        return newItems;
      } else {
        // 移除所有当前页的数据
        const changeIds = changeRows.map(row => row.id);
        return items.filter(item => !changeIds.includes(item.id));
      }
    });
  };

  const tabItems = [
    {
      key: 'APP',
      label: '应用',
    },
    {
      key: 'WORKFLOW', 
      label: '工作流',
    },
    {
      key: 'AGENT',
      label: '智能体',
    }
  ];

  return (
    <div className={styles.choiceApplication}>
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={tabItems}
        style={{ marginBottom: 16 }}
      />

      {/* 应用类型过滤器，只在APP标签页显示 */}
      {activeTab === 'APP' && (
        <div style={{ marginBottom: 16 }}>
          <ApplicationTypeFilter
            onChange={handleAppFilterChange}
          />
        </div>
      )}

      {/* 工作流和智能体的搜索框 */}
      {activeTab !== 'APP' && (
        <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
          <Search
            placeholder={`搜索${activeTab === 'WORKFLOW' ? '工作流' : '智能体'}名称`}
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            onSearch={handleSearch}
            style={{ width: 300 }}
            allowClear
          />
        </Space>
      )}
      
        <div className={styles.label}>
        已选择 {currentSelectItems.length} 个{activeTab === 'APP' ? '应用' : activeTab === 'WORKFLOW' ? '工作流' : '智能体'}
        </div>

        <div className={styles.table}>
          <Table
          loading={loading}
            rowSelection={{
              type: 'checkbox',
            selectedRowKeys: currentSelectItems.map(item => item.id),
            onSelect: handleSelect,
            onSelectAll: handleSelectAll,
            }}
            scroll={{
            x: activeTab === 'APP' ? 600 : 1200, // 工作流和智能体需要更宽的滚动区域
            y: 400 // 从450px减少到400px，为分页区域留出更多空间
            }}
          columns={getColumns(activeTab)}
            dataSource={data}
          rowKey="id"
          pagination={{
            current: pageInfo.current.current,
            pageSize: pageInfo.current.pageSize,
            total: total,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total, range) => `共 ${total} 条记录，显示第 ${range[0]}-${range[1]} 条`,
            onChange: (page) => {
              pageInfo.current.current = page;
              loadData();
            }
          }}
        />
      </div>
    </div>
  )
}

function ChoiceApplication(choiceIds, onChange, type = null) {
  let selectItems = [];
  
  // 创建一个容器来承载React组件
  const container = document.createElement('div');
  document.body.appendChild(container);
  
  // 使用ReactDOM渲染普通Modal
  const root = ReactDOM.createRoot(container);
  
  const ModalComponent = () => {
    const [visible, setVisible] = useState(true);
    const [loading, setLoading] = useState(false);
    
    const handleOk = async () => {
      setLoading(true);
      const status = await onChange(selectItems);
      if (status) {
        setVisible(false);
        setTimeout(() => {
          root.unmount();
          document.body.removeChild(container);
        }, 300);
      }
      setLoading(false);
    };
    
    const handleCancel = () => {
      setVisible(false);
      setTimeout(() => {
        root.unmount();
        document.body.removeChild(container);
      }, 300);
    };
    
    return (
      <Modal
        title="选择应用"
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1700} // 从1500增加到1700
        centered
        destroyOnClose
        okText="确定"
        cancelText="取消"
        confirmLoading={loading}
        okButtonProps={{
          style: {
            backgroundColor: '#7860FE',
            borderColor: '#7860FE',
            color: 'white'
          },
          className: 'primaryButton'
        }}
        cancelButtonProps={{
          className: 'cancelButton'
        }}
        style={{
          maxWidth: '98vw', // 从95vw增加到98vw
        }}
        styles={{
          body: {
            height: 'calc(90vh - 120px)', // 从85vh增加到90vh
            maxHeight: '750px', // 从650px增加到750px
            minHeight: '500px', // 从450px增加到500px
            overflow: 'hidden',
            padding: '24px'
          }
        }}
        className="choice-application-modal"
      >
        <ChoiceApplicationContent
          choiceIds={choiceIds || []}
          type={type}
          onChange={(items) => {
            const _list = delRepeatData(items, 'id');
            selectItems = _list;
          }}
        />
      </Modal>
    );
  };
  
  root.render(<ModalComponent />);
  
  // 返回一个销毁函数
  return {
    destroy: () => {
      root.unmount();
      document.body.removeChild(container);
    }
  };
}

export default ChoiceApplication;